'use client'
import * as React from 'react'
import Script from 'next/script'

import {
  GoogleOneTapLogin,
  scriptUrl as googleOneTapLoginScriptUrl,
} from '@repo/analytics/google-one-tap-login'
import { useIsLoggedInQuery } from 'auth/hooks'
import { getCookie, deleteCookie } from 'utils/dom'

const MANAGE_SUBSCRIPTION_RETURN_COOKIE = 'cf_manage_sub_return'
const MANAGE_SUBSCRIPTION_RETURN_URL =
  '/my-account/manage-subscription/?load-compensation-options=1'

export const GlobalOneTapLogin = () => {
  const isLoggedInQuery = useIsLoggedInQuery()

  React.useEffect(() => {
    if (isLoggedInQuery.data) {
      const { google } = window
      if (google) {
        google.accounts.id.cancel()
      }

      if (getCookie(MANAGE_SUBSCRIPTION_RETURN_COOKIE) === '1') {
        deleteCookie(MANAGE_SUBSCRIPTION_RETURN_COOKIE)
        const alreadyOnTarget =
          window.location.pathname + window.location.search === MANAGE_SUBSCRIPTION_RETURN_URL
        if (!alreadyOnTarget) {
          window.location.href = MANAGE_SUBSCRIPTION_RETURN_URL
        }
      }
    }
  }, [isLoggedInQuery.data])

  if (isLoggedInQuery.isFetching || isLoggedInQuery.data) {
    return null
  }

  const redirectUrl =
    typeof window !== 'undefined'
      ? getCookie(MANAGE_SUBSCRIPTION_RETURN_COOKIE) === '1'
        ? `${window.location.origin}${MANAGE_SUBSCRIPTION_RETURN_URL}`
        : window.location.href
      : ''

  return (
    <>
      <GoogleOneTapLogin redirectUrl={redirectUrl} />
      <Script
        id="global-one-tap-login-script"
        src={googleOneTapLoginScriptUrl}
        strategy="afterInteractive"
      />
    </>
  )
}
